export function isCanvasBlank(canvas) {
    const context = canvas.getContext('2d')

    const pixelBuffer = new Uint32Array(
        context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
    )

    return !pixelBuffer.some(color => color !== 0)
}

export const setItemInStore = (key, value) => {
    if (typeof value === 'object') {
        return localStorage.setItem(key, JSON.stringify(value))
    }

    return localStorage.setItem(key, value)
}

export const getItemFromStore = key => {
    const value = localStorage.getItem(key)

    try {
        return JSON.parse(value)
    } catch (e) {
        return value // error will throw if value is not a proper JSON string, so return value
    }
}

export const getElementById = id => {
    return document.getElementById(id)
}

export const getElementByQuerySelector = queryString => {
    return document.querySelector(queryString)
}

export const showElement = queryString => {
    const element = getElementByQuerySelector(queryString)

    if (element) {
        element.style.setProperty('display', 'block')
    }
}

export const hideElement = queryString => {
    const element = getElementByQuerySelector(queryString)

    if (element) {
        element.style.setProperty('display', 'none')
    }
}

export const isElementVisibleInViewport = element => {
    if (element) {
        const rect = element.getBoundingClientRect()

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
        )
    }
}
